import './index.scss';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { requests as newClientRequest } from 'redux/cars/newClient/reducer';
import { getStatusNewClient } from 'redux/cars/newClient/selector';
import { getCountryProfile } from 'redux/profile/selector';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { Portlet, PortletBody } from 'components/partials/content/Portlet';
import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';

import Step1, { initialValues as initialValuesStep1 } from './step1';
import validateStep1 from './step1/validate';
import Step2, { initialValues as initialValuesStep2 } from './step2';
import validateStep2 from './step2/validate';
import Step3, { initialValues as initialValuesStep3 } from './step3';
import validateStep3 from './step3/validate';
import Step4 from './step4';
import validateStep4 from './step4/validate';
import Step5 from './step5';

const maxStep = 4;

const schemaArray = (intl, country) => ({
  '1': validateStep1(intl),
  '2': validateStep2(intl),
  '3': validateStep3(intl, country),
  '4': validateStep4(intl, country),
  '5': Yup.object().shape({}),
});

const initialValues = {
  warratyCode: '',
  ...initialValuesStep1,
  ...initialValuesStep2,
  ...initialValuesStep3,
};

const NewClientForm = ({
  intl,
  onSubmit,
  isLoading,
  hasError,
  code,
  isSuccess,
  country,
}) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    if (!isLoading && !hasError && isSuccess) {
      setStep(5);
      window.scrollTo(0, 0);
    }
  }, [isLoading, hasError, isSuccess]);

  const prevStep = () => setStep(step - 1);

  const nextStep = (values, bag) => {
    if (step === maxStep) {
      return onSubmit(values);
    }
    bag.setSubmitting(false);
    return setStep(step + 1);
  };

  return (
    <Portlet className="kt-portlet--height-fluid NewClientForm">
      <PorletHeader>
        <div className="kt-space-20" />
        <div className="row">
          <div className="col-sm-12 col-md-1" />
          <div className="col-sm-12 col-md-10">
            <div className="row stepper">
              <div className="col-sm-12 col-md-3">
                <div className={step === 1 ? 'active' : ''}>
                  <PorletHeaderTitle variant="h4">1</PorletHeaderTitle>
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Cliente" />
                  </PorletHeaderTitle>
                </div>
              </div>
              <div className="col-sm-12 col-md-3">
                <div className={step === 2 ? 'active' : ''}>
                  <PorletHeaderTitle variant="h4">2</PorletHeaderTitle>
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Vehículo" />
                  </PorletHeaderTitle>
                </div>
              </div>
              <div className="col-sm-12 col-md-3">
                <div className={step === 3 ? 'active' : ''}>
                  <PorletHeaderTitle variant="h4">3</PorletHeaderTitle>
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Aplicación" />
                  </PorletHeaderTitle>
                </div>
              </div>
              <div className="col-sm-12 col-md-3">
                <div className={step >= 4 ? 'active' : ''}>
                  <PorletHeaderTitle variant="h4">4</PorletHeaderTitle>
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Resumen" />
                  </PorletHeaderTitle>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-1" />
        </div>
      </PorletHeader>
      <PortletBody>
        <Formik
          initialValues={initialValues}
          onSubmit={nextStep}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={schemaArray(intl, country)[step]}
        >
          {(props) => (
            <Form>
              {step === 1 && <Step1 {...props} prevStep={prevStep} />}
              {step === 2 && <Step2 {...props} prevStep={prevStep} />}
              {step === 3 && (
                <Step3 {...props} country={country} prevStep={prevStep} />
              )}
              {step === 4 && (
                <Step4
                  {...props}
                  country={country}
                  isLoading={isLoading}
                  prevStep={prevStep}
                />
              )}
              {step === 5 && <Step5 {...props} code={code} />}
              {/*  <pre>{JSON.stringify(props.values, null, '\t')}</pre>*/}
            </Form>
          )}
        </Formik>
      </PortletBody>
    </Portlet>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: (values) => dispatch(newClientRequest.create({ body: values })),
});

export default injectIntl(
  connect(
    (state) => ({
      ...getStatusNewClient(state),
      country: getCountryProfile(state),
    }),
    mapDispatchToProps,
  )(NewClientForm),
);
